import Vue from 'vue'

import formLabel from './formLabel'
import Loading from './Loading'

Vue.component('form-label', formLabel)
Vue.component('Loading', Loading)
